<template>
  <v-btn
    :color="color"
    :disabled="disabled"
    :loading="loading"
    class="text-none px-6"
    :class="{
      'text-white': !darkText,
      'rounded-pill': shape === 'pill',
      'rounded-lg': shape === 'box',
    }"
    @click="emitClick"
    variant="elevated"
    :elevation="elevation"
  >
    <slot></slot>
  </v-btn>
</template>
<script setup lang="ts">
interface Props {
  loading?: boolean
  disabled?: boolean
  color?: string
  darkText?: boolean
  elevation?: number
  shape?: 'box' | 'pill'
}

const {
  loading = false,
  disabled = false,
  color = 'pwt_palatinate_blue',
  darkText = false,
  elevation = undefined,
  shape = 'pill',
} = defineProps<Props>()

const emit = defineEmits(['click'])

function emitClick() {
  emit('click')
}
</script>
